// extracted by mini-css-extract-plugin
module.exports = {"unSupported":"UnSupported_unSupported__dJDv2"};